import { render } from "./SkeletonBottom.vue?vue&type=template&id=436ae3bb"
import script from "./SkeletonBottom.vue?vue&type=script&lang=js"
export * from "./SkeletonBottom.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__